import React, { FC } from 'react';

const CarIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.24833 1.25541C9.14 0.935828 8.83667 0.708328 8.47917 0.708328H2.52083C2.16333 0.708328 1.86542 0.935828 1.75167 1.25541L0.625 4.49999V8.83333C0.625 9.13125 0.86875 9.375 1.16667 9.375H1.70833C2.00625 9.375 2.25 9.13125 2.25 8.83333V8.29166H8.75V8.83333C8.75 9.13125 8.99375 9.375 9.29167 9.375H9.83333C10.1313 9.375 10.375 9.13125 10.375 8.83333V4.49999L9.24833 1.25541ZM2.71042 1.79166H8.28417L8.86917 3.47624H2.12542L2.71042 1.79166ZM9.29167 7.20833H1.70833V4.49999H9.29167V7.20833Z"
        fill="#currentColor"
      />
      <path
        d="M3.0625 6.66667C3.51123 6.66667 3.875 6.3029 3.875 5.85417C3.875 5.40544 3.51123 5.04167 3.0625 5.04167C2.61377 5.04167 2.25 5.40544 2.25 5.85417C2.25 6.3029 2.61377 6.66667 3.0625 6.66667Z"
        fill="#currentColor"
      />
      <path
        d="M7.9375 6.66667C8.38623 6.66667 8.75 6.3029 8.75 5.85417C8.75 5.40544 8.38623 5.04167 7.9375 5.04167C7.48877 5.04167 7.125 5.40544 7.125 5.85417C7.125 6.3029 7.48877 6.66667 7.9375 6.66667Z"
        fill="#currentColor"
      />
    </svg>
  );
};

export default CarIcon;
